<template>
  <div class="text-center">
    <div v-if="$auth().check()">
      <strong>Hallo {{ $auth().user().firstname }}! </strong>
      <a href="#" class="text-decoration-none">
        <strong>Account</strong>
      </a>
      <br />
      <a
        href="#"
        class="text-decoration-none"
        data-bs-toggle="modal"
        data-bs-target="#larativo-member-login-modal"
        onclick="event.preventDefault;"
      >
        <small>Jetzt abmelden</small>
      </a>
    </div>
    <div v-else>
      <div id="booking-login">
        <p class="p-0">Du bist nicht angemeldet.
            <a
            href="#"
            class="text-decoration-none"
            data-bs-toggle="modal"
            data-bs-target="#larativo-member-login-modal"
            onclick="event.preventDefault;"
            >
            <strong>Jetzt anmelden</strong>
            </a>
        </p>
        <small>Du hast keinen Account? </small>
        <a
          :href="$route('larativo.member.register')"
          target="_blank"
          class="text-decoration-none link-dark"
        >
          <small>Jetzt registrieren</small>
        </a>
      </div>
    </div>
  </div>
</template>
